import * as React from "react";

export const AppaIcon = () => (
  <svg
    width="100%"
    height={184}
    viewBox="0 0 646 184"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2001_1242"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={646}
      height={185}
    >
      <path d="M645.671 0.00195312H0.328125V184.002H645.671V0.00195312Z" fill="black" />
      <path d="M645.671 0.00195312H0.328125V184.002H645.671V0.00195312Z" fill="white" />
    </mask>
    <g mask="url(#mask0_2001_1242)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.255 180.706C54.5157 190.762 15.8879 175.61 7.85324 162.7C0.464019 150.809 0.328125 122.051 0.328125 109.447C0.328125 96.8426 0.464019 68.1181 7.85324 54.155C15.871 38.9519 54.5157 13.3869 128.255 3.27985C201.994 -6.82724 240.622 8.37587 248.657 21.3028C256.046 33.1934 256.182 61.935 256.182 74.5391C256.182 87.1432 256.046 115.868 248.657 129.848C240.622 145.034 201.994 170.65 128.255 180.706Z"
        fill="#C41230"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M288.016 80.0599L288.39 84.4595H293.163L290.768 63.8716H286.012L275.072 84.4595H279.625L281.85 80.0599H288.016ZM287.507 68.0673C287.461 68.899 287.461 69.7326 287.507 70.5643L288.033 77.359H283.226L286.538 70.5643C286.947 69.7679 287.271 68.931 287.507 68.0673Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M308.91 78.361C308.1 82.255 304.557 84.9662 300.587 84.7311C297.019 84.7311 294.488 82.8455 294.488 79.635C294.492 79.1733 294.538 78.7128 294.624 78.2591L297.631 63.8374H302.472L299.499 78.2251C299.431 78.5322 299.391 78.845 299.38 79.1594C299.312 79.6852 299.492 80.2128 299.869 80.5861C300.246 80.9593 300.775 81.1353 301.3 81.0619C302.904 81.0676 304.263 79.8828 304.476 78.2931L307.415 63.9053H311.951L308.91 78.361Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M323.247 67.6435C322.382 67.1341 321.396 66.8699 320.393 66.8791C319.573 66.8555 318.78 67.1696 318.199 67.7476C317.618 68.3257 317.299 69.1171 317.318 69.9367C317.318 72.7734 322.856 72.7395 322.856 77.2749C322.845 79.3791 321.954 81.3827 320.398 82.7996C318.842 84.2165 316.764 84.9174 314.668 84.7321C312.832 84.8678 310.997 84.4475 309.402 83.526L311.101 80.3325C311.984 80.8896 313.013 81.1732 314.057 81.1479C314.934 81.1991 315.794 80.8883 316.436 80.2879C317.078 79.6876 317.446 78.8503 317.454 77.9714C317.454 75.1856 312.358 75.1856 312.358 70.7181C312.396 68.7348 313.24 66.8524 314.694 65.5036C316.149 64.1548 318.089 63.4556 320.07 63.5667C321.71 63.4946 323.335 63.9082 324.741 64.7557L323.247 67.6435Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M337.956 67.1158H334.423L330.856 84.4592H325.98L329.565 67.1497H326.031L326.694 63.9053H338.585L337.956 67.1158Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M347.535 75.406C349.31 75.1512 350.932 74.2645 352.105 72.9089C353.102 71.7291 353.66 70.2407 353.685 68.6962C353.685 65.6386 351.34 63.6002 346.601 63.6002C344.414 63.5655 342.242 63.9699 340.214 64.7893L336.154 84.4599H340.928L342.966 75.2871L346.075 84.4599H351.171L347.535 75.406ZM344.614 66.5729C345.119 66.4147 345.646 66.3345 346.176 66.3351C348.062 66.3351 348.86 67.1165 348.911 68.7132C348.92 70.0848 348.505 71.4255 347.722 72.5522C346.847 73.5924 345.548 74.1796 344.189 74.1489C343.823 74.1495 343.459 74.1096 343.102 74.03L344.614 66.5729Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M364.149 80.0257L364.574 84.4592H369.347L366.952 63.9053H362.23L351.273 84.4592H355.826L358.017 80.0257H364.149ZM363.708 68.067V70.5641L364.149 77.3588H359.342L362.739 70.5641C363.13 69.7597 363.454 68.9245 363.708 68.067Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M380.304 84.4592H370.23L374.494 63.9053H379.335L375.768 81.2147H380.983L380.304 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M393.961 80.0596L394.318 84.4592H399.108L396.713 63.9053H391.957L381.018 84.4592H385.57L387.812 80.0596H393.961ZM393.469 68.067C393.424 68.8988 393.424 69.7323 393.469 70.5641L393.995 77.3588H389.205L392.518 70.5641C392.908 69.7615 393.226 68.9259 393.469 68.067Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M413.836 67.6435C412.979 67.1339 411.997 66.8695 411 66.8791C410.179 66.8506 409.383 67.163 408.8 67.7421C408.218 68.3213 407.901 69.1157 407.925 69.9367C407.925 72.7735 413.446 72.7395 413.446 77.2749C413.435 79.3792 412.543 81.3827 410.988 82.7996C409.432 84.2166 407.354 84.9174 405.258 84.7321C403.422 84.8657 401.587 84.4456 399.992 83.526L401.691 80.3325C402.582 80.8873 403.614 81.1706 404.664 81.1479C405.541 81.1991 406.401 80.8883 407.043 80.288C407.685 79.6876 408.053 78.8503 408.061 77.9714C408.061 75.1856 402.965 75.1856 402.965 70.7181C402.999 68.7363 403.838 66.8538 405.29 65.5045C406.742 64.1552 408.681 63.4555 410.66 63.5667C412.3 63.4915 413.926 63.9054 415.331 64.7557L413.836 67.6435Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M418.881 84.4592H414.006L418.253 63.9053H423.128L418.881 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M433.269 80.0596L433.625 84.4592H438.416L436.021 63.9053H431.264L420.342 84.4592H424.86L427.119 80.0596H433.269ZM432.759 68.067C432.714 68.8987 432.714 69.7323 432.759 70.5641L433.286 77.3588H428.495L431.808 70.5641C432.207 69.7654 432.526 68.9289 432.759 68.067Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M455.402 84.4592H451.852L447.384 72.8743C447.122 72.1727 446.895 71.4584 446.705 70.7339C446.515 70.0095 446.569 71.8381 446.331 72.9762L443.987 84.4592H439.91L444.157 63.9053H448.285L452.429 74.42C452.854 75.4562 453.126 76.4075 453.126 76.4075C453.126 76.4075 453.262 75.4392 453.466 74.3521L455.606 63.9053H459.683L455.402 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M478.724 76.7812C481.523 76.9979 484.267 75.9288 486.182 73.8765C487.381 72.4117 488.057 70.5882 488.101 68.6956C488.101 65.8078 486.097 63.5995 481.306 63.5995C479.102 63.5547 476.911 63.9593 474.868 64.7886L470.809 84.4592H475.548L477.145 76.6793C477.668 76.7487 478.196 76.7828 478.724 76.7812ZM479.166 66.5552C479.717 66.3882 480.29 66.308 480.865 66.3174C482.733 66.3174 483.481 67.1498 483.413 68.6106C483.389 69.7946 483.092 70.957 482.546 72.008C481.764 73.3065 480.3 74.0349 478.792 73.8765C478.419 73.9027 478.044 73.9027 477.671 73.8765L479.166 66.5552Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M498.446 75.4064C500.221 75.1546 501.845 74.2674 503.016 72.9094C504.033 71.7401 504.599 70.2462 504.612 68.6967C504.612 65.6221 502.268 63.6006 497.529 63.6006C495.347 63.5622 493.18 63.9667 491.159 64.7897L487.082 84.4603H491.855L493.894 75.2875L497.002 84.4603H502.098L498.446 75.4064ZM495.558 66.5733C496.058 66.415 496.58 66.3348 497.104 66.3355C498.99 66.3355 499.856 67.1169 499.856 68.7137C499.86 70.0898 499.432 71.4325 498.633 72.5526C497.763 73.599 496.46 74.1876 495.1 74.1494C494.74 74.1491 494.381 74.1092 494.03 74.0305L495.558 66.5733Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M511.306 84.7653C514.2 84.8235 516.934 83.4347 518.593 81.0622C520.588 77.9473 521.66 74.3312 521.685 70.6324C521.685 66.5726 519.85 63.5659 515.332 63.5659C512.45 63.5724 509.751 64.9788 508.095 67.337C506.049 70.3463 504.933 73.8904 504.885 77.529C504.885 81.8096 506.94 84.7653 511.306 84.7653ZM511.578 69.885C512.427 68.1183 513.497 66.7934 514.975 66.7934V66.7594C516.538 66.7594 517.03 68.0164 517.03 69.7151C516.859 72.5737 516.222 75.3851 515.145 78.0386C514.329 79.8562 513.361 81.1641 511.747 81.1641C510.134 81.1641 509.59 79.9071 509.59 78.2085C509.755 75.3382 510.428 72.52 511.578 69.885Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M542.272 84.4592H537.822L539.283 72.4666C539.436 71.1926 539.69 69.9016 539.69 69.9016C539.391 70.7821 539.028 71.6394 538.603 72.4666L532.522 84.4592H530.11L529.074 72.4666C528.955 71.1586 528.955 69.9016 528.955 69.9016C528.847 70.7706 528.665 71.6287 528.411 72.4666L524.827 84.4592H520.699L527.12 63.9053H531.877L532.709 75.6771C532.749 76.4126 532.749 77.1498 532.709 77.8853C532.973 77.1302 533.285 76.3926 533.643 75.6771L539.537 63.9053H544.26L542.272 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M551.665 84.7656C554.564 84.8204 557.3 83.433 558.969 81.0625C560.97 77.9609 562.053 74.3572 562.095 70.6667C562.095 66.6068 560.26 63.6002 555.725 63.6002C552.842 63.5876 550.135 64.9826 548.472 67.3373C546.421 70.3451 545.298 73.8891 545.244 77.5293C545.244 81.8099 547.3 84.7656 551.665 84.7656ZM551.954 69.8853C552.803 68.1186 553.856 66.7937 555.351 66.7937V66.7597C556.897 66.7597 557.407 68.0167 557.424 69.7494C557.254 72.5955 556.623 75.3952 555.555 78.0389C554.723 79.8565 553.788 81.1644 552.158 81.1644C550.527 81.1644 550 79.9074 550 78.2087C550.17 75.3428 550.831 72.5273 551.954 69.8853Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M575.43 67.1158H571.863L568.313 84.4592H563.438L567.039 67.1497H563.505L564.168 63.9053H576.059L575.43 67.1158Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M578.641 84.4592H573.766L578.012 63.9053H582.887L578.641 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M589.155 84.7656C592.051 84.8268 594.785 83.4373 596.443 81.0625C598.461 77.9673 599.557 74.3615 599.602 70.6666C599.602 66.6068 597.734 63.6001 593.215 63.6001C590.329 63.5907 587.617 64.9843 585.945 67.3372C583.905 70.3496 582.79 73.8918 582.734 77.5292C582.734 81.8099 584.79 84.7656 589.155 84.7656ZM589.444 69.8852C590.293 68.1186 591.347 66.7936 592.841 66.7936V66.7597C594.387 66.7597 594.897 68.0167 594.914 69.7493C594.747 72.5976 594.11 75.3985 593.028 78.0388C592.196 79.8564 591.262 81.1644 589.631 81.1644C588 81.1644 587.474 79.9074 587.474 78.2087C587.633 75.3395 588.3 72.5212 589.444 69.8852Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M614.771 84.4592H611.221L606.736 72.9082C606.465 72.2099 606.238 71.495 606.057 70.7679C605.876 70.0408 605.938 71.872 605.683 73.0102L603.271 84.4592H599.211L603.441 63.9053H607.568L611.73 74.42C611.994 75.0692 612.221 75.7327 612.41 76.4075C612.598 77.0823 612.528 75.4392 612.749 74.3521L614.907 63.9053H618.949L614.771 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M628.565 80.0596L628.921 84.4592H633.712L631.231 63.9053H626.492L615.553 84.4592H620.156L622.347 80.0596H628.565ZM628.038 68.067V70.5641L628.514 77.3588H623.672L627.07 70.5641C627.478 69.7676 627.803 68.9308 628.038 68.067Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M644.991 84.4592H634.9L639.147 63.9053H643.988L640.455 81.1977H645.67L644.991 84.4592Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M279.693 109.821C282.496 110.038 285.246 108.969 287.167 106.916C288.369 105.443 289.034 103.603 289.052 101.701C289.052 98.8136 287.048 96.6054 282.258 96.6054C280.051 96.5572 277.859 96.9679 275.82 97.8114L271.76 117.465H276.533L278.113 109.736C278.622 109.821 279.149 109.821 279.693 109.821ZM280.151 99.595C280.702 99.428 281.275 99.3478 281.85 99.3572C283.701 99.3572 284.483 100.19 284.415 101.633C284.389 102.821 284.08 103.986 283.515 105.031C282.745 106.336 281.285 107.073 279.777 106.916C279.399 106.951 279.018 106.951 278.639 106.916L280.151 99.595Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M299.21 108.445C300.981 108.194 302.603 107.313 303.779 105.965C304.801 104.76 305.361 103.231 305.359 101.651C305.359 98.593 303.032 96.5546 298.276 96.5546C296.092 96.5215 293.925 96.9318 291.906 97.7606L287.846 117.414H292.602L294.504 108.241L297.749 117.397H302.845L299.21 108.445ZM296.339 99.6292C296.841 99.455 297.37 99.3688 297.902 99.3744C299.753 99.3744 300.603 100.173 300.637 101.753C300.647 103.127 300.225 104.47 299.431 105.592C298.554 106.638 297.246 107.227 295.88 107.188C295.52 107.197 295.16 107.157 294.81 107.069L296.339 99.6292Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M311.932 117.771C314.825 117.823 317.556 116.436 319.219 114.068C321.223 110.973 322.312 107.376 322.362 103.689C322.362 99.6292 320.51 96.6056 315.992 96.6056C313.109 96.5902 310.4 97.9858 308.739 100.343C306.687 103.351 305.559 106.894 305.494 110.535C305.494 114.815 307.566 117.771 311.932 117.771ZM312.204 102.84C313.07 101.073 314.106 99.7481 315.601 99.7481C317.164 99.7481 317.657 101.073 317.657 102.721C317.495 105.563 316.864 108.358 315.788 110.993C314.956 112.828 314.004 114.119 312.391 114.119C310.777 114.119 310.233 112.862 310.233 111.163C310.4 108.295 311.067 105.478 312.204 102.84Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M328.121 117.771C331.253 117.941 334.284 116.633 336.309 114.237C338.467 111.252 339.658 107.677 339.723 103.994C339.723 99.7647 337.566 96.6731 332.215 96.6731C330.102 96.6293 328.005 97.0407 326.066 97.8791L322.176 116.565C324.034 117.433 326.072 117.846 328.121 117.771ZM330.397 99.9855C330.872 99.8214 331.373 99.7409 331.875 99.7477C334.033 99.7477 335.001 100.852 335.001 103.145C334.849 106.173 334.08 109.139 332.742 111.859C332.057 113.424 330.508 114.432 328.801 114.424C328.343 114.439 327.887 114.364 327.459 114.203L330.397 99.9855Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M354.739 111.4C353.914 115.293 350.371 117.999 346.398 117.77C342.831 117.77 340.283 115.885 340.283 112.674C340.301 112.212 340.358 111.751 340.453 111.298L343.426 96.8765H348.267L345.328 111.281C345.255 111.582 345.209 111.889 345.192 112.198C345.132 112.729 345.324 113.257 345.711 113.625C346.099 113.992 346.636 114.156 347.163 114.067C348.767 114.089 350.133 112.906 350.339 111.315L353.295 96.9104H357.797L354.739 111.4Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M370.622 100.58C369.989 100.229 369.273 100.053 368.549 100.071C367.126 100.117 365.805 100.827 364.982 101.99C363.371 104.332 362.49 107.098 362.451 109.94C362.451 112.403 363.318 113.966 365.407 113.966C366.316 113.965 367.213 113.75 368.023 113.337L368.465 116.548C367.094 117.379 365.514 117.797 363.912 117.754C359.462 117.754 357.457 114.356 357.457 110.246C357.442 106.044 359.069 102.002 361.993 98.9835C363.644 97.4344 365.827 96.5773 368.091 96.5884C369.59 96.5142 371.071 96.9382 372.304 97.7945L370.622 100.58Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M384.822 100.172H381.255L377.739 117.465H372.812L376.397 100.172H372.88L373.543 96.9106H385.434L384.822 100.172Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M396.424 100.699C395.573 100.173 394.588 99.9013 393.587 99.9176C392.765 99.8894 391.967 100.201 391.382 100.78C390.797 101.358 390.477 102.153 390.496 102.975C390.496 105.812 396.034 105.778 396.034 110.33C396.013 112.43 395.118 114.426 393.564 115.838C392.01 117.25 389.938 117.95 387.846 117.771C386.01 117.904 384.175 117.484 382.58 116.565L384.279 113.371C385.166 113.917 386.193 114.194 387.234 114.169C388.109 114.23 388.969 113.928 389.612 113.333C390.256 112.738 390.625 111.903 390.632 111.027C390.632 108.241 385.536 108.241 385.536 103.757C385.574 101.77 386.42 99.8851 387.878 98.5357C389.336 97.1864 391.281 96.4893 393.265 96.6052C394.902 96.5292 396.525 96.9496 397.919 97.8113L396.424 100.699Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M420.46 113.082L420.834 117.465H425.658L423.263 96.9106H418.507L407.533 117.465H412.086L414.311 113.082H420.46ZM419.967 101.106C419.917 101.927 419.917 102.749 419.967 103.569L420.443 110.364H415.619L419.016 103.569C419.412 102.781 419.73 101.956 419.967 101.106Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M440.59 100.7C439.737 100.18 438.753 99.9147 437.753 99.9351C436.933 99.902 436.135 100.21 435.549 100.786C434.964 101.362 434.642 102.155 434.662 102.976C434.662 105.813 440.217 105.796 440.217 110.331C440.191 112.432 439.292 114.428 437.736 115.839C436.179 117.251 434.106 117.951 432.012 117.771C430.176 117.905 428.341 117.485 426.746 116.565L428.445 113.372C429.33 113.924 430.357 114.207 431.4 114.187C432.289 114.263 433.169 113.965 433.83 113.366C434.49 112.766 434.872 111.919 434.883 111.027C434.883 108.242 429.787 108.242 429.787 103.757C429.821 101.775 430.66 99.8929 432.112 98.5436C433.564 97.1943 435.503 96.4945 437.482 96.6057C439.124 96.5378 440.749 96.9574 442.153 97.8118L440.59 100.7Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M454.417 100.699C453.563 100.179 452.579 99.914 451.58 99.9344C450.761 99.9011 449.965 100.21 449.382 100.786C448.799 101.363 448.481 102.155 448.506 102.975C448.506 105.812 454.043 105.795 454.043 110.33C454.018 112.435 453.117 114.433 451.557 115.845C449.996 117.257 447.918 117.955 445.822 117.77C443.996 117.901 442.174 117.481 440.59 116.564L442.289 113.337C443.179 113.892 444.212 114.175 445.261 114.152C446.136 114.203 446.993 113.895 447.635 113.298C448.276 112.702 448.646 111.869 448.659 110.993C448.659 108.207 443.563 108.207 443.563 103.722C443.601 101.736 444.446 99.8509 445.905 98.5016C447.363 97.1522 449.308 96.4552 451.291 96.571C452.923 96.4995 454.539 96.9197 455.929 97.7771L454.417 100.699Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.351 117.771C465.248 117.842 467.987 116.45 469.638 114.068C471.653 110.978 472.749 107.378 472.798 103.689C472.798 99.6292 470.929 96.6056 466.427 96.6056C463.539 96.5904 460.826 97.9853 459.157 100.343C457.106 103.351 455.984 106.895 455.93 110.535C455.93 114.815 457.985 117.771 462.351 117.771ZM462.673 102.823C463.523 101.056 464.576 99.7481 466.071 99.7481C467.599 99.7481 468.092 101.073 468.109 102.704C467.939 105.544 467.308 108.339 466.241 110.976C465.442 112.811 464.44 114.119 462.843 114.119C461.246 114.119 460.703 112.845 460.703 111.146C460.864 108.277 461.531 105.459 462.673 102.823Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M486.997 100.579C486.363 100.23 485.648 100.054 484.924 100.07C483.496 100.1 482.169 100.814 481.357 101.989C479.734 104.326 478.847 107.094 478.809 109.939C478.809 112.385 479.675 113.948 481.765 113.948C482.674 113.947 483.57 113.732 484.381 113.319L484.754 116.564C483.393 117.4 481.816 117.819 480.219 117.77C475.768 117.77 473.764 114.372 473.764 110.279C473.737 106.069 475.366 102.018 478.299 98.9994C479.957 97.4492 482.145 96.5922 484.415 96.6042C485.913 96.5388 487.391 96.9621 488.627 97.8103L486.997 100.579Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M491.957 117.465H487.082L491.329 96.9106H496.204L491.957 117.465Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M506.294 113.082L506.668 117.465H511.458L509.063 96.9106H504.307L493.367 117.465H497.92L500.145 113.082H506.294ZM505.801 101.106C505.801 101.106 505.717 102.194 505.801 103.569L506.345 110.364H501.538L504.833 103.569C505.229 102.779 505.553 101.955 505.801 101.106Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M525.353 100.172H521.82L518.253 117.465H513.395L517.03 100.172H513.513L514.176 96.9106H526.067L525.353 100.172Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M528.665 117.465H523.824L528.071 96.9106H532.963L528.665 117.465Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M538.891 117.771C541.786 117.832 544.521 116.443 546.178 114.068C548.177 110.972 549.26 107.374 549.304 103.689C549.304 99.6292 547.469 96.6055 542.951 96.6055C540.064 96.5932 537.351 97.9875 535.681 100.343C533.63 103.35 532.507 106.895 532.453 110.535C532.453 114.815 534.509 117.771 538.891 117.771ZM539.112 102.823C539.944 101.056 540.997 99.7481 542.509 99.7481C544.208 99.7481 544.616 101.073 544.548 102.704C544.378 105.544 543.747 108.339 542.679 110.976C541.864 112.811 540.879 114.119 539.282 114.119C537.685 114.119 537.141 112.845 537.141 111.146C537.311 108.278 537.977 105.462 539.112 102.823Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M564.134 117.465H560.584L556.1 105.948C555.692 104.86 555.42 103.773 555.42 103.773C555.42 103.773 555.301 104.894 555.064 106.033L552.702 117.465H548.643L552.889 96.9106H557L561.162 107.425C561.436 108.076 561.663 108.746 561.841 109.43C562.019 110.113 561.977 108.445 562.181 107.374L564.355 96.9106H568.398L564.134 117.465Z"
        fill="#545456"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0188 101.904C19.0993 113.455 26.1148 119.434 41.6576 119.451C50.9494 119.468 58.5254 117.838 63.4855 115.357L69.1591 82.3523C71.7581 67.2511 63.6724 61.9683 51.4929 61.9683C44.2843 61.9879 37.148 63.4071 30.4804 66.147L32.2979 75.3198C36.8877 73.2642 41.83 72.1108 46.8555 71.9225C52.5631 71.9395 56.0793 73.5872 55.0771 79.3626L54.5675 81.8597C38.1074 83.3885 23.4988 87.5842 21.0188 101.904ZM35.7293 101.309C37.2751 92.4594 43.747 90.2002 53.2935 89.2829L49.8962 109.48C48.0132 110.28 45.979 110.663 43.9339 110.601C37.7337 110.584 34.6251 107.798 35.7293 101.309Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.3248 118.281C92.8069 118.968 95.3772 119.283 97.9518 119.215C111.932 119.249 123.534 108.242 126.608 90.4396C129.802 71.7882 121.122 61.9529 105.035 61.9529C97.7157 61.6995 90.4336 63.1048 83.7339 66.0637L70.875 140.635H86.4688L90.3248 118.281ZM98.2575 72.2469C99.8323 71.6625 101.505 71.3857 103.184 71.4315C111.49 71.4315 113.342 78.1582 111.184 90.6095C109.027 103.061 104.186 109.754 95.8964 109.754C94.5362 109.775 93.1852 109.527 91.9215 109.023L98.2575 72.2469Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.263 118.364C149.747 119.041 152.316 119.356 154.89 119.298C168.887 119.315 180.472 108.24 183.58 90.4886C186.791 71.8372 178.077 62.0359 162.007 62.0359C154.677 61.7696 147.383 63.1693 140.672 66.1297L127.83 140.718H143.424L147.263 118.364ZM155.196 72.3128C156.779 71.7371 158.455 71.4606 160.139 71.4975C168.428 71.5145 170.28 78.2072 168.123 90.6755C165.965 103.144 161.124 109.819 152.835 109.819C151.473 109.856 150.119 109.607 148.86 109.089L155.196 72.3128Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.017 102.142C187.029 113.676 193.994 119.689 209.571 119.689C218.778 119.706 226.354 118.058 231.365 115.68L237.089 82.5051C239.671 67.404 231.586 62.1211 219.406 62.1211C212.196 62.1448 205.06 63.5698 198.394 66.3168L200.211 75.4896C204.802 73.4183 209.753 72.2643 214.786 72.0923C220.476 72.0923 223.976 73.74 222.99 79.5155L222.549 82.0975C206.089 83.6263 191.48 87.822 189.017 102.142ZM203.625 101.581C205.154 92.7142 211.643 90.4549 221.19 89.5546L217.707 109.735C215.847 110.529 213.836 110.912 211.813 110.856C205.63 110.856 202.504 108.07 203.625 101.581Z"
        fill="white"
      />
    </g>
  </svg>
);
